const translations = {
    archiveFailed: 'Archive Failed',
    connectionError: 'Connection Error',
    saveFailed: 'Save Failed'
};

export default translations;
